import { FormattedMessage } from "react-intl";

type Props = {
  bank: any;
  className?: string;
};

/** Compact bank block for subscription pages (plans sidebar / reuse). */
const SubscriptionBankSummary = ({ bank, className = "" }: Props) => {
  const hasAny =
    bank &&
    (bank.payment_instructions ||
      bank.account_holder_name ||
      bank.bank_name ||
      bank.account_number ||
      bank.iban ||
      bank.swift_bic);

  if (!hasAny) {
    return (
      <div className={className}>
        <p className="text-muted small mb-0">
          <FormattedMessage
            id="subscription_bank_placeholder"
            defaultMessage="Bank transfer details will appear here once your administrator has configured them."
          />
        </p>
      </div>
    );
  }

  return (
    <div className={className}>
      {bank.payment_instructions && (
        <p className="text-muted small">{bank.payment_instructions}</p>
      )}
      <ul className="list-unstyled small mb-0">
        {bank.account_holder_name && (
          <li className="mb-2">
            <strong>
              <FormattedMessage id="account_holder" defaultMessage="Account holder" />:
            </strong>{" "}
            {bank.account_holder_name}
          </li>
        )}
        {bank.bank_name && (
          <li className="mb-2">
            <strong>
              <FormattedMessage id="bank_name" defaultMessage="Bank name" />:
            </strong>{" "}
            {bank.bank_name}
          </li>
        )}
        {bank.account_number && (
          <li className="mb-2">
            <strong>
              <FormattedMessage id="account_number" defaultMessage="Account number" />:
            </strong>{" "}
            {bank.account_number}
          </li>
        )}
        {bank.iban && (
          <li className="mb-2">
            <strong>IBAN:</strong> {bank.iban}
          </li>
        )}
        {bank.swift_bic && (
          <li className="mb-0">
            <strong>SWIFT / BIC:</strong> {bank.swift_bic}
          </li>
        )}
      </ul>
    </div>
  );
};

export default SubscriptionBankSummary;
